import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layouts/index.vue'
import AttendanceLatout from '@/layouts/attendance.vue'
import ScreenLatout from '@/layouts/data_screen.vue'
import VerificationLatout from '@/layouts/verification.vue'
import Do from '@/layouts/do.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/dataScreen',
      name: '设备保障数据大屏',
      component: ScreenLatout,
      children: [
        {
          path: '/assestsProblem',
          name: 'dataScreen',
          component: () =>  import('@/view/data_screen/assestsProblem.vue'),
        },
        {
          path: '/welcome',
          name: 'welcome',
          component: () =>  import('@/view/screen/welcome.vue'),
        },
      ]
    },
    {
      path: '/',
      name: 'home',
      component: Layout,
      children: [
        {
          path: '/myAttendance',
          name: 'myAttendance',
          component: () => import('@/view/attendance/myAttendance.vue'),
        },
        {
          path: '/',
          name: 'sys_data',
          component: () => import('@/view/sys_data/index1.vue'),
        },
        {
          path: '/problem',
          name: 'problem',
          component: () => import('@/view/problem/index.vue'),
        },
        {
          path: '/examine',
          name: 'examine',
          component: () => import('@/view/examine/index.vue'),
        },
        {
          path: '/examine/department/list',
          name: 'examineDepartment',
          component: () => import('@/view/examine/department/list.vue'),
        },
        {
          path: '/examine/department/:id(\\d+)',
          name: '部门考核详情',
          component: () => import('@/view/examine/department/index.vue'),
        },
        {
          path: '/examine/department/total',
          name: 'departmentTotal',
          component: () => import('@/view/examine/department/total.vue'),
        },
        {
          path: '/examine/workshop/list',
          name: 'examineWorkshop',
          component: () => import('@/view/examine/workshop/list.vue'),
        },
        {
          path: '/examine/workshop/:id(\\d+)',
          name: '车间考核详情',
          component: () => import('@/view/examine/workshop/index.vue'),
        },
        {
          path: '/examine/workshop/total',
          name: 'workshopTotal',
          component: () => import('@/view/examine/workshop/total.vue'),
        },
        {
          path: '/examine/warehouse/list',
          name: 'examineWarehouse',
          component: () => import('@/view/examine/warehouse/list.vue'),
        },
        {
          path: '/examine/warehouse/:id(\\d+)',
          name: '仓库考核详情',
          component: () => import('@/view/examine/warehouse/index.vue'),
        },
        {
          path: '/examine/logistics/list',
          name: 'examineLogistics',
          component: () => import('@/view/examine/logistics/list.vue'),
        },
        {
          path: '/examine/logistics/:id(\\d+)',
          name: '后勤部门考核详情',
          component: () => import('@/view/examine/logistics/index.vue'),
        },
        {
          path: '/examine/device/list',
          name: 'examineDevice',
          component: () => import('@/view/examine/device/list.vue'),
        },
        {
          path: '/examine/device/:id(\\d+)',
          name: '设备保养评分详情',
          component: () => import('@/view/examine/device/index.vue'),
        },
        {
          path: '/examine/satisfactionDepart/list',
          name: 'examineSatisfactionDepartList',
          component: () => import('@/view/examine/satisfaction/list.vue'),
          props:{satisfactionType:1}
        },
        {
          path: '/examine/satisfactionChejian/list',
          name: 'examineSatisfactionChejianList',
          component: () => import('@/view/examine/satisfaction/list.vue'),
          props:{satisfactionType:2}
        },
        {
          path: '/examine/satisfactionChejian/:id(\\d+)',
          name: '车间评分详情',
          component: () => import('@/view/examine/satisfaction/index.vue'),
        },
        {
          path: '/examine/satisfactionDepart/:id(\\d+)',
          name: '部门评分详情',
          component: () => import('@/view/examine/satisfaction/depart.vue'),
        },
        {
          path: '/examine/satisfactionDepart/total',
          name: 'satisfactionDepartTotal',
          component: () => import('@/view/examine/satisfaction/total.vue'),
        },
        {
          path: '/assessment/:id(\\d+)',
          name: '绩效考核评分详情',
          component: () => import('@/view/assessment/index.vue'),

        },
        {
          path: '/assessment/list',
          name: 'assessmentList',
          component: () => import('@/view/assessment/list.vue'),
          meta: {
            keepAlive: true // 开启缓存
          }
        },
        {
          path: '/assessment/total',
          name: 'assessmentTotal',
          component: () => import('@/view/assessment/total.vue'),
        },
        {
          path: '/problem_score',
          name: 'problem_score',
          component: () => import('@/view/problem/score.vue'),
        },
        {
          path: '/problem/detail/:id(\\d+)',
          name: '问题详情',
          component: () => import('@/view/problem/detail.vue'),
        },
        {
          path: '/problem/myProblem',
          name: 'myProblem',
          component: () => import('@/view/problem/myProblem.vue'),
        },
        {
          path: '/problem/examine',
          name: 'examineProblem',
          component: () => import('@/view/problem/examine.vue'),
        },
        {
          path: '/logintime',
          name: 'logintime',
          component: () => import('@/view/user/logintime.vue'),
        },
        {
          path: '/subscribe',
          name: 'subscribe',
          component: () => import('@/view/user/subscribe.vue'),
        },
        {
          path: '/holiday',
          name: 'holiday',
          component: () => import('@/view/attendance/holiday.vue'),
        },
        {
          path: '/writeCheckinout',
          name: 'writeCheckinout',
          component: () => import('@/view/attendance/writeCheckinout.vue'),
        },
        {
          path: '/login',
          name: '登录',
          component: () => import('@/view/user/login.vue'),
        },
        { path: '/mold/list', component: () => import('@/view/project/mold/list.vue')},

        //新项目
        { path: '/project/create',name:'projectCreate', component: () => import('@/view/project/create.vue')},
        { path: '/project/myProjectList',name:'myProjectList', component: () => import('@/view/project/myProjectList.vue')},
        { path: '/project/list',name:'projectList', component: () => import('@/view/project/list.vue')},
        { path: '/project/:id', component: () => import('@/view/project/index.vue') },
        { path: '/project/trip', name:'trip', component: () => import('@/view/project/trip.vue') },
        { path: '/summary',name:'summary', component: () => import('@/view/project/summary.vue') },


        { path: '/assets',name:'assets', component: () => import('@/view/device_assets/assets.vue') },
        { path: '/device',name:'device', component: () => import('@/view/device_assets/device.vue') },
        { path: '/chejian', component: () => import('@/view/device_assets/chejian.vue') },
        { path: '/taker', component: () => import('@/view/device_assets/taker.vue') },
        { path: '/center', component: () => import('@/view/user/center.vue') },
        //申报
        {
          path: '/report/create',name:'createReport', component: () => import('@/view/report/create.vue')
        },
        {
          path: '/report/list',name:'reportList', component: () => import('@/view/report/list.vue')
        },
        {
          path: '/report/myList',name:'myReportList', component: () => import('@/view/report/my_list.vue')
        },
        {
          path: '/report/:id(\\d+)', component: () => import('@/view/report/index.vue')
        },
        {
          path: '/report/edit/:id(\\d+)',name:'edit',component: () => import('@/view/report/edit.vue')
        },
        {
          path: '/report/approve',name:'approve',component: () => import('@/view/report/approve.vue')
        },
        {
          path: '/verification/create',name:'createVerification',component: () => import('@/view/verification/create.vue')
        },
        {
          path: '/verification/dataList',name:'dataList',component: () => import('@/view/verification/dataList.vue')
        },
        {
          path: '/meeting/index',name:'meeting',component: () => import('@/view/meeting/index.vue')
        },
        //水电费
        {
          path: '/hostel/add',name:'hostelAdd',component: () => import('@/view/hostel/add.vue')
        },
        {
          path: '/hostel/room',name:'hostelRoom',component: () => import('@/view/hostel/room.vue')
        },
        {
          path: '/hostel/index',name:'hostelIndex',component: () => import('@/view/hostel/index.vue')
        },
        {
          path: '/hostel/total',name:'hostelTotal',component: () => import('@/view/hostel/total.vue')
        },
        {
          path: '/term/import',name:'termImport',component: () => import('@/view/term/import.vue')
        },
        {
          path: '/term/index',name:'termIndex',component: () => import('@/view/term/index.vue')
        },
        {
          path: '/term/add',name:'termAdd',component: () => import('@/view/term/add.vue')
        },
        {
          path: '/term/read',name:'termRead',component: () => import('@/view/term/read.vue')
        },
        //培训
        {
          path: '/training/add',name:'trainingAdd',component: () => import('@/view/training/add.vue')
        },
        {
          path: '/training/detail/:id(\\d+)',name:'trainingDetail',component: () => import('@/view/training/detail.vue')
        },
        {
          path: '/training/list',name:'trainingList',component: () => import('@/view/training/list.vue')
        },


        {
          path: '/training/paper/list',name:'trainingPaperList',component: () => import('@/view/training/exam/paper/list.vue')
        },
        {
          path: '/training/paper/edit',name:'trainingPaperEdit',component: () => import('@/view/training/exam/paper/edit.vue')
        },
        {
          path: '/training/paper/allCreate',name:'trainingPaperAllCreate',component: () => import('@/view/training/exam/paper/allCreate.vue')
        },
        //题目编辑
        {
          path: '/training/question/list',name:'questionList',component: () => import('@/view/training/exam/question/list.vue')
        },
        {
          path: '/training/question/single_choice',name:'singleChoice',component: () => import('@/view/training/exam/question/single_choice.vue')
        },
        {
          path: '/training/question/multiple_choice',name:'multipleChoice',component: () => import('@/view/training/exam/question/multiple_choice.vue')
        },
        {
          path: '/training/question/true_false',name:'trueFalse',component: () => import('@/view/training/exam/question/true_false.vue')
        },

        {
          path: '/training/total',name:'trainingTotal',component: () => import('@/view/training/total/index.vue')
        },
        {
          path: '/accessory/statistics',name:'accessoryStatistics',component: () => import('@/view/accessory/statistics.vue')
        },
        {
          path: '/accessory/factory',name:'accessoryFactory',component: () => import('@/view/accessory/factory.vue')
        },
        {
          path: '/accessory/material',name:'accessoryMaterial',component: () => import('@/view/accessory/material.vue')
        },
        {
          path: '/tool/template',name:'template',component: () => import('@/view/tool/template.vue')
        },
      ]
    },
    {
      path: '/',
      name: 'home',
      component: AttendanceLatout,
      children:[
        {
          path: '/attendance',
          name: 'attendance',
          component: () => import('@/view/attendance/index.vue'),
        },
        {
          path: '/absentee',
          name: 'absentee',
          component: () => import('@/view/attendance/absentee.vue'),
        },
        {
          path: '/workshop',
          name: 'workshop',
          component: () => import('@/view/attendance/workshop.vue'),
        },
        {
          path: '/total',
          name: 'total',
          component: () => import('@/view/attendance/total.vue'),
        },
        {
          path: '/examineCard',
          name: 'examine',
          component: () => import('@/view/attendance/examine.vue'),
        },
        {
          path: '/calibration',
          name: 'calibration',
          component: () => import('@/view/attendance/calibration.vue'),
        },
        {
          path: '/worktimerule',
          name: '补卡',
          component: () => import('@/view/attendance/rule.vue'),
        },
        {
          path: '/workovertime',
          name: '查看连续上班',
          component: () => import('@/view/attendance/WorkOvertime.vue'),
        },
        {
          path: '/lackCheckinout',
          name: '查看缺卡',
          component: () => import('@/view/attendance/LackCheckinout.vue'),
        },
        {
          path: '/DayLackCheckinout',
          name: '查看每天缺卡',
          component: () => import('@/view/attendance/DayLackCheckinout.vue'),
        },
        {
          path: '/importCheckinout',
          name: '导入考勤',
          component: () => import('@/view/attendance/import.vue'),
        },
        {
          path: '/worklateTotal',
          name: 'worklateTotal',
          component: () => import('@/view/attendance/worklateTotal.vue'),
        },
        {
          path: '/worktimeTotal',
          name: 'worktimeTotal',
          component: () => import('@/view/attendance/worktimeTotal.vue'),
        },
        {
          path: '/lateTotal',
          name: 'lateTotal',
          component: () => import('@/view/attendance/lateTotal.vue'),
        },
      ]
    },
    {
      path: '/',
      name: 'home',
      component: VerificationLatout,
      children:[
        //质检
        {
          path: '/verification/:id(\\d+)',name:'Verification',component: () => import('@/view/verification/index.vue')
        },
        {
          path: '/verification/list',name:'listVerification',component: () => import('@/view/verification/list.vue')
        },
        {
          path: '/verification/followList',name:'followVerification',component: () => import('@/view/verification/list.vue')
        },
        {
          path: '/verification/verificationList',name:'verificationList',component: () => import('@/view/verification/list.vue')
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js